<template>
  <BasicLayout>
    <template #wrapper>
      <el-card :bordered="false" :body-style="{padding: '0'}">

        <div class="salesCard">
          <el-form :inline="true">
            <el-form-item label="类型">
              <el-select v-model="queryParams1.type" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="开始日期">
              <el-date-picker
                v-model="queryParams1.startDate"
                placeholder="请选择日期"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="结束日期">
              <el-date-picker
                v-model="queryParams1.endDate"
                placeholder="请选择日期"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery(0)">查询</el-button>
              <el-button v-if="isExport" type="primary" icon="el-icon-download" size="mini" @click="handleQuery(1)">导出</el-button>
            </el-form-item>
          </el-form>
          <div ref="chartContainer" style="width: 100%; height: 400px;" />
        </div>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import echarts from 'echarts'
import { getUserDataAvgStat } from '@/api/statistics/user_remain'
import { dateStrTodate, getLastDates } from '@/utils'
export default {
  name: 'IndexUserDataAvg',
  props: {
    isExport: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      options: [
        { label: '全部', value: 0 },
        { label: '未付费', value: 1 },
        { label: '付费', value: 2 }
      ],
      chartData: {},
      queryParams1: {
        startDate: '',
        endDate: '',
        type: 0,
        level: 0
      }
    }
  },
  created() {
    this.queryParams1.endDate = getLastDates(1)
    this.queryParams1.startDate = getLastDates(7)
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleQuery(isExport = 0) {
      if (!this.queryParams1.startDate) {
        this.msgError('开始日期不能为空')
        return
      }

      if (!this.queryParams1.endDate) {
        this.msgError('结束日期不能为空')
        return
      }
      this.initChart(isExport)
    },
    initChart(isExport = 0) {
      const chart = echarts.init(this.$refs.chartContainer)
      const option = {
        color: ['#00BFFF', '#FF69B4', '#FF7F50', '#BA55D3', '#FFA500', '#7B68EE'],
        title: {
          text: '人均数值'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: ['活跃人均在线时长', '注册人均在线时长', '人均消耗', '人均次数', '人均bet', '人均登录次数', '人均通关次数'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: { readOnly: false },
            // magicType: { type: ['line', 'bar'] },
            // restore: {},
            // saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '活跃人均在线时长',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '注册人均在线时长',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '人均消耗',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '人均次数',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '人均bet',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '人均登录次数',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '人均通关次数',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
        ]
      }
      chart.setOption(option)
      chart.showLoading()
      setTimeout(() => {
        this.loading = true
        this.queryParams1.level = 0
        if (isExport) {
          this.queryParams1.level = 1
        }
        getUserDataAvgStat(this.queryParams1).then(res => {
          this.loading = false
          chart.hideLoading()
          if (res.code === 200) {
            if (this.queryParams1.level === 1) {
              window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
            }
            if (res.data.length < 1) {
              return
            }
            const date = []
            const dauOnline = []
            const regOnline = []
            const consumeData = []
            const slotData = []
            const betData = []
            const logCountData = []
            const playlevelData = []
            res.data.data.forEach(item => {
              date.push(dateStrTodate(item.date))
              dauOnline.push(item.log_onlone)
              regOnline.push(item.reg_online)
              consumeData.push(item.consume)
              slotData.push(item.count)
              betData.push(item.bet)
              logCountData.push(item.login)
              playlevelData.push(item.play_level)
            })

            option.xAxis.data = date
            option.series[0].data = dauOnline
            option.series[1].data = regOnline
            option.series[2].data = consumeData
            option.series[3].data = slotData
            option.series[4].data = betData
            option.series[5].data = logCountData
            option.series[6].data = playlevelData
            chart.setOption(option)
          } else {
            this.msgError(res.msg)
          }
        })
      }, 800)
    }
  }
}
</script>

  <style scoped />
